<template>
    <ui-modal :title="title" :close="() => { close(); afterClose?afterClose():null; }">
        <template #icon>
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <svg class="h-6 w-6 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-2 -2 28 28"
                     stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                          d="M16 22.621l-3.521-6.795c-.007.004-1.974.97-2.064 1.011-2.24 1.086-6.799-7.82-4.609-8.994l2.082-1.026-3.492-6.817-2.106 1.039c-1.639.855-2.313 2.666-2.289 4.916.075 6.948 6.809 18.071 12.309 18.045.541-.003 1.07-.113 1.58-.346.121-.055 2.102-1.029 2.11-1.033zm-2.5-13.621c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm9 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm-4.5 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5z"/>
                </svg>
            </div>
        </template>
        <div class="flex my-2">
            <dl class="grid gap-x-4 gap-y-2 grid-cols-12">
                <div class="col-span-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1" v-text="'Percent'"></label>
                    <input name="percent" v-model="percent"
                           placeholder="%" class="mb-0"
                           @change="changePercent"
                           @input="updatePercent"
                    />
                </div>
                <div class="col-span-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1" v-text="'Discount Value'"></label>
                    <input name="discount" v-model="discount"
                           placeholder="%" class="mb-0"
                           @change="changeDiscount"
                           @input="updateDiscount"
                    />
                </div>
                <div class="col-span-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1" v-text="'Scope of Works Total'"></label>
                    <input name="value" v-model="total"
                           placeholder="%" class="mb-0"
                           @change="changeTotal"
                           @input="updateTotal"
                    />
                </div>
                <div class="col-span-12 text-xs text-gray-400" v-if="estimate.mcd">Note - "Grand Total" is calculated AFTER any MCD has been
                    applied (currently <span class="font-semibold">{{ this.estimate.mcd }}%</span>)
                </div>
                <ui-textarea name="Comment" v-model="comment"
                             label="Adjustment Comment"
                             placeholder="Estimate adjustment..."
                             class="md:col-span-12 mt-4">
                </ui-textarea>
            </dl>
        </div>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
                <ui-button-new primary class="w-full whitespace-nowrap" :loading="form.busy" @click="form.submit(); close()"
                               v-text="button"></ui-button-new>
            </span>
        </template>
    </ui-modal>
</template>

<script>
import UiInput from "../../ui/UiInput.vue";
import PackageContactSearch from "../../contacts/PackageContactSearch.vue";
import UiDataGridItem from "../../ui/UiDataGridItem.vue";
import UiDataGrid from "../../ui/UiDataGrid.vue";
import UiTextarea from "../../ui/UiTextarea.vue";
import {resolveNumericText} from "../../../utils";
import {toCurrency} from '@utils'

export default {
    components: {UiTextarea, UiDataGrid, UiDataGridItem, PackageContactSearch, UiInput},
    props: {
        handle: Function,
        close: Function,
        afterClose: Function,
        title: {
            type: String,
            default: 'Estimate Adjustment'
        },
        button: {
            type: String,
            default: 'Apply Adjustment'
        },
        resolveNumericText,
        estimate: Object,
    },
    data() {
        const v = this.calculateTotal();
        return {
            form: new Form({}, async (form) => {
                await this.handle({percent: this.rawPercent,comment: this.comment})
            }),
            rawPercent: this.estimate.adjustment,
            percent: (Math.round(this.estimate.adjustment * 100) / 100) + '%',
            discount: toCurrency(this.estimate.adjustment ? v * (this.estimate.adjustment / 100) : 0),
            total: toCurrency((v - (v * (this.estimate.mcd / 100))) - Math.round((this.estimate.adjustment ? ((v - (v * (this.estimate.mcd / 100))) * (this.estimate.adjustment / 100)) : 0) * 100) / 100),
            comment: this.estimate.adjustmentComment,
        }
    },
    methods: {
        updatePercent(o) {
            let percent = Math.max(0, Math.min(100, resolveNumericText(o.target.value)))
            let v = this.calculateTotal();
            this.rawPercent = percent;
            this.discount = toCurrency((percent ? (v * (percent / 100)) : 0))
            this.total = toCurrency(((v - (v * (this.estimate.mcd / 100))) - Math.round((percent ? ((v - (v * (this.estimate.mcd / 100))) * (percent / 100)) : 0) * 100) / 100));
        },
        changePercent(o) {
            let percent = Math.max(0, Math.min(100, resolveNumericText(o.target.value)))
            let v = this.calculateTotal();
            this.discount = toCurrency((percent ? v * (percent / 100) : 0))
            this.total = toCurrency((v - (v * (this.estimate.mcd / 100))) - Math.round((percent ? ((v - (v * (this.estimate.mcd / 100))) * (percent / 100)) : 0) * 100) / 100)
            this.percent = (Math.round(percent * 100) / 100) + '%'
            this.rawPercent = percent;
        },
        updateDiscount(o) {
            let v = this.calculateTotal();
            let discount = Math.max(0, Math.min(v, resolveNumericText(o.target.value)))
            let percent = v ? (discount / v) * 100 : 0;
            this.rawPercent = percent;
            this.percent = (Math.round(percent * 100) / 100) + '%'
            this.total = toCurrency(((v - (v * (this.estimate.mcd / 100))) - Math.round((percent ? ((v - (v * (this.estimate.mcd / 100))) * (percent / 100)) : 0) * 100) / 100))
        },
        changeDiscount(o) {
            let v = this.calculateTotal();
            let discount = Math.max(0, Math.min(v, resolveNumericText(o.target.value)))
            let percent = v ? (discount / v) * 100 : 0;
            this.rawPercent = percent;
            this.percent = (Math.round(percent * 100) / 100) + '%'
            this.total = toCurrency(((v - (v * (this.estimate.mcd / 100))) - Math.round((percent ? ((v - (v * (this.estimate.mcd / 100))) * (percent / 100)) : 0) * 100) / 100))
            this.discount = toCurrency((percent ? v * (percent / 100) : 0))
        },
        updateTotal(o) {
            let v = this.calculateTotal()
            let total = Math.min(v/ (1-(this.estimate.mcd/100)),Math.max(0,v-(resolveNumericText(o.target.value)/ (1-(this.estimate.mcd/100)))))
            let percent = v ? (total / v) * 100 : 0;
            this.rawPercent = percent;
            this.percent = (Math.round(percent * 100) / 100) + '%'
            this.discount = toCurrency(total)
        },
        changeTotal(o) {
            let v = this.calculateTotal()
            let total = Math.min(v/ (1-(this.estimate.mcd/100)),Math.max(0,v-(resolveNumericText(o.target.value)/ (1-(this.estimate.mcd/100)))))
            let percent = v ? (total / v) * 100 : 0;
            this.rawPercent = percent;
            this.percent = (Math.round(percent * 100) / 100) + '%'
            this.discount = toCurrency(total)
            this.total = toCurrency(((v - (v * (this.estimate.mcd / 100))) - Math.round((percent ? ((v - (v * (this.estimate.mcd / 100))) * (percent / 100)) : 0) * 100) / 100))
        },
        calculateTotal() {
            return Math.round(this.estimate.scopeOfWorks.filter((i) => !i.optional).reduce((a, section) => a + section.tasks.reduce(
                (a, task) => a + (task.items.reduce(
                        (a, item) => a + (item.total ? item.total : 0), 0)
                ), 0
            ), 0) * 100) / 100
        },
    },
    mounted() {
    }
}
</script>
